__turbopack_context__.v({
  "axisDot": "Ig4nzG_axisDot",
  "axisDotActive": "Ig4nzG_axisDotActive",
  "axisStrip": "Ig4nzG_axisStrip",
  "dropdown": "Ig4nzG_dropdown",
  "dropdownOpen": "Ig4nzG_dropdownOpen",
  "fieldValue": "Ig4nzG_fieldValue",
  "fieldValueVisible": "Ig4nzG_fieldValueVisible",
  "fieldWrap": "Ig4nzG_fieldWrap",
  "form": "Ig4nzG_form",
  "legend": "Ig4nzG_legend",
  "legendDot": "Ig4nzG_legendDot",
  "legendLabel": "Ig4nzG_legendLabel",
  "legendValue": "Ig4nzG_legendValue",
  "legendVisible": "Ig4nzG_legendVisible",
  "monthLabel": "Ig4nzG_monthLabel",
  "monthLabelMarked": "Ig4nzG_monthLabelMarked",
  "option": "Ig4nzG_option",
  "optionHighlighted": "Ig4nzG_optionHighlighted",
  "placeholder": "Ig4nzG_placeholder",
  "placeholderHidden": "Ig4nzG_placeholderHidden",
  "root": "Ig4nzG_root",
  "select": "Ig4nzG_select",
});
